<template>
  <v-container id="extended-tables" fluid tag="section">
    <span class="subheading"> # Atención Médica: {{ numero_examen }}</span>
    <v-stepper v-model="e6" vertical>
      <v-stepper-step :complete="e6 > 1" step="1">
        Ingrese los sintomas
        <small>Resumir de los sintomas</small>
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-autocomplete
          v-model="sintoma_uq"
          :items="sintomas"
          item-text="sintoma"
          item-value="unico"
          label="Seleccione Sintomas que presenta la mascota"
          dense
          filled
          return-object
          v-on:change="GuardarSintoma()"
        >
        </v-autocomplete>

        <v-data-table
          :headers="headersSintomasExamenMedico"
          :items="sintomasExamenMedico"
          sort-by="sintoma"
          class="elevation-1"
          hide-default-footer
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  large
                  @click="DeleteSintomaExamenMedico(item)"
                >
                  <v-icon dense color="primary">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar sintoma</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-textarea
          name="input-7-1"
          filled
          label="Descripción de Sintomas"
          auto-grow
          v-model="sintoma"
        ></v-textarea>
        <v-btn
          color="primary"
          @click="(e6 = 2), ActualizarExamenMedico(), listarCitas()"
        >
          Continuar
        </v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 2" step="2">
        Seleccionar el horario disponible
        <small>Horarios disponibles del personal médico</small>
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Seleccione Fecha"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            v-on:change="listarCitas()"
            :min="minimo"
          ></v-date-picker>
        </v-menu>
        <v-combobox
          v-model="horario"
          :items="horarios"
          label="Horarios Disponibles"
          outlined
          dense
          item-text="timeValue"
          item-value="timeValue"
          persistent-hint
          return-object
          single-line
        ></v-combobox>
        <v-btn
          color="primary"
          @click="(e6 = 3), consultarTarifa(), ConfirmarHorario()"
        >
          Continuar
        </v-btn>
        <v-btn color="secondary" @click="e6 = 1"> Regresar </v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 3" step="3">
        Realizar pago
        <small>Seleccione el medio de pago más conveniente para ti</small>
      </v-stepper-step>
      <v-stepper-content step="3">
        <v-alert dense type="info">
          Costo de la consulta ${{ tarifa }} <br />
          * Consulta via zoom por 15 minutos
        </v-alert>
        <v-tabs
          v-model="tab"
          background-color="secondary"
          centered
          dark
          icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>
          <!--
                <v-tab href="#tab-1">
                  Datafast
                  <v-icon>mdi-credit-card</v-icon>
                </v-tab>
                -->
          <v-tab href="#tab-2">
            Transferencia Bancaria
            <v-icon>mdi-bank</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!--
                <v-tab-item :value="'tab-1'"> text </v-tab-item>
               -->
          <v-tab-item :value="'tab-2'">
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-card class="mx-auto" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="text-h3 mb-4">BANCO PICHINCHA</div>
                      <div class="text-h3 mb-4">CUENTA AHORROS 4322667767</div>
                      <div class="text-h3 mb-4">DDFD fgfg</div>
                      <div class="text-h3 mb-4">Ci: 17171</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-card class="mx-auto" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="text-h3 mb-4">PRODUBANCO</div>
                      <div class="text-h3 mb-4">CUENTA AHORROS 4322667767</div>
                      <div class="text-h3 mb-4">JJJ JKJK</div>
                      <div class="text-h3 mb-4">Ci: 17171</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" sm="10" md="10">
                <v-file-input
                  :rules="rulesUpload"
                  show-size
                  accept="image/png, image/jpeg, image/bmp"
                  label="Seleccionar imagen de la transferencia"
                  filled
                  prepend-icon="mdi-camera"
                  @change="onFileSelected"
                  ref="fileInput"
                  type="file"
                >
                </v-file-input>
              </v-col>
              <v-col cols="2" sm="2" md="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="success"
                      fab
                      v-on="on"
                      @click="UploadImagenPago()"
                      :loading="loading"
                      :disabled="loading"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Cargar imagen</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-carousel :show-arrows="false" height="auto" width="auto">
                  <v-carousel-item
                    v-for="(item, i) in itemsFotosPagos"
                    :key="i"
                    :src="item.src"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                    cover
                  ></v-carousel-item>
                </v-carousel>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </v-tab-item>
        </v-tabs-items>

        <v-spacer></v-spacer>
        <v-btn color="primary" @click="ConfirmarProceso()"> Continuar </v-btn>
        <v-btn color="secondary" @click="e6 = 2"> Regresar </v-btn>
      </v-stepper-content>

      <v-stepper-step step="4">
        Esperar la confirmación por email
        <small>Revisa tu link de zoom</small>
      </v-stepper-step>
      <v-stepper-content step="4">
        <v-card color="grey lighten-1" class="mb-12" height="100px">
          <v-card-text>
            Tu atención médica ha sido agendada exitosamente. En un minutos
            revisa tu correo elcetrónico con el link de la video consulta.
          </v-card-text>
        </v-card>
      </v-stepper-content>
    </v-stepper>
    <v-dialog v-model="dialogConfirmar" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">
          Estas seguro de culminar el proceso de ingreso de datos?
        </v-card-title>
        <v-card-text class="text-h5">
          <small> * el proceso no se reversa</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogConfirmar = false"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="ConfirmarCierre()"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: "AtencionMedicaOnlineComponent",
  data: () => ({
    e6: 1,
    sintomas: [],
    sintoma_uq: "",
    headersSintomasExamenMedico: [
      {
        text: "Sintomas ingresados",
        align: "start",
        sortable: false,
        value: "sintoma",
      },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    sintomasExamenMedico: [],
    sintoma: "",
    menu2: false,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    minimo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    horario: "",
    horarios: [],
    tab: null,
    rulesUpload: [
      (value) => !value || value.size < 9000000 || "Tamaño máximo 9MB!",
    ],
    loader: null,
    loading: false,
    itemsFotosPagos: [
      {
        src: "",
      },
    ],
    dialogConfirmar: false,
    tarifa: 0,
    numero_examen: 0,
  }),

  

  watch: {
   
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
    component_mascota_uq: function (nuevoValor) {
      console.log("El valor del padre ha cambiado a:", nuevoValor);
      this.component_usuario_uq = nuevoValor;
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let me = this;
    console.log("Ingrese componente");
    //this.listar();
    me.listarSintomas();

      me.ValidarVeterinarioMascota();
        //enecerar
    me.sintomasExamenMedico = [];
    me.sintoma = "";
    me.e6 = 1;
  },
  ValidarVeterinarioMascota() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    var registros = [];
    axios
      .get(
        "api/VeterinariosMascotas/Validar/" + me.component_mascota_uq,//me.unico_mascota,
        configuracion
      )
      .then(function (response) {
        registros = response.data;
        if (registros.length > 0) {
          console.log("existe registros");
          //existe un registro  abierto
          me.veterinario_mascota_uq = registros[0]["unico"];
          me.ListarExamenMedico();
          if (registros[0]["cierre_usuario"] == true) {
            //si esta cerrado envia a l ultimo paso
            me.e6 = 4;
          }
        } else {
          //crear nuevo
          console.log("nuevos registros");
          me.VeterinarioMascotaCrear();
        }
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  ListarExamenMedico() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    var registros = [];
    axios
      .get(
        "/api/ExamenesMedicos/ListarPorVeterinarioMascota/" +
          me.veterinario_mascota_uq,
        configuracion
      )
      .then(function (response) {
        registros = response.data;
        me.examen_medico_uq = registros[0]["unico"];
        me.sintoma = registros[0]["sintomas"];
        me.numero_examen = registros[0]["identity_column"];
        me.ListarSintomasDeExamenMedico();
        me.selectFotosPagos();
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
      });
  },
  listarSintomas() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    axios
      .get("api/Sintomas", configuracion)
      .then(function (response) {
        me.sintomas = response.data;
        //change to string bool value
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  
  GuardarSintoma() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    //crear la relacion Veterinario mascotas con el veterinario que no tiene asignacion
    // var registros=[];
    axios
      .post(
        "/api/ExamenesMedicosSintomas/Crear",
        {
          examen_medico_uq: me.examen_medico_uq,
          sintoma_uq: me.sintoma_uq.unico,
        },
        configuracion
      )
      .then(function (response) {
        console.log(response);
        me.ListarSintomasDeExamenMedico();
        me.sintoma_uq = null;
        //registros=response.data;
        //me.examen_medico_uq=registros.unico;
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.dispatch("salir");
        }
        if (err.response.status == 400) {
          me.sintoma_uq = null;
        }
      });
  },
  DeleteSintomaExamenMedico(item) {
    let me = this;
    console.log("entre borrar");
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    axios
      .delete("api/ExamenesMedicosSintomas/" + item.unico, configuracion)
      .then(function () {
        me.ListarSintomasDeExamenMedico();
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  ActualizarExamenMedico() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };

    //edit
    console.log("Actualizar  exmane medico" + me.examen_medico_uq);
    axios
      .put(
        "/api/ExamenesMedicos/Actualizar/" + me.examen_medico_uq,
        {
          unico: me.examen_medico_uq,
          sintomas: me.sintoma,
          diagnostico: "",
          recomendacion: "",
        },
        configuracion
      )
      .then(function (response) {
        // me.listar();
        console.log(response);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.dispatch("salir");
        }
      });
  },
  listarCitas() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    me.horarios = [];
    axios
      .get("api/Citas/ListarCitas/" + me.date, configuracion)
      .then(function (response) {
        me.horarios = response.data;
        //change to string bool value
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  ConfirmarHorario() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
      axios
      .put(
        "api/VeterinariosMascotas/ConfirmarHorario/" +
          me.veterinario_mascota_uq +
          "/" +
          me.date +
          " " +
          me.horario.timeValue, {},         
        configuracion
      )
      .then(function (response) {
      console.log(response);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.dispatch("salir");
        }
      });
  },
  consultarTarifa() {
    let me = this;

    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    axios
      .get("api/Tarifas", configuracion)
      .then(function (response) {
        var array = response.data;
        me.tarifa = array[0]["valor"];
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  onFileSelected(event) {
    console.log(event);
    if (event != null) {
      this.selectedFile = event;
      this.fileName = this.selectedFile["name"];
    } else {
      this.selectedFile = null;
      this.fileName = "";
    }
  },
  selectFotosPagos() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    console.log("llenar fotos:" + me.examen_medico_uq);
    axios
      .get("api/Imagenes/ListarPagos/" + me.examen_medico_uq, configuracion)
      .then(function (response) {
        console.log("f pagos:");
        me.itemsFotosPagos = response.data;
        console.log(me.itemsFotosPagos);
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  ConfirmarProceso() {
    let me = this;
    me.dialogConfirmar = true;
  },
  UploadImagenPago() {
    let me = this;
    console.log("upload paciente: unicoPaciente");
    if (me.selectedFile != null) {
      me.loader = "loading";
      console.log("pase null");
      const fd = new FormData();
      fd.append("image", me.selectedFile, me.selectedFile.name);
      let header = { Authorization: "Bearer " + me.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "/api/Imagenes/UploadConvert64Pagos/" + me.examen_medico_uq,
          fd,
          configuracion
        )
        .then((res) => {
          console.log(res);
          this.selectFotosPagos();
          this.loader = null;
        });
    }
  },
  VeterinarioMascotaCrear() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    //crear la relacion Veterinario mascotas con el veterinario que no tiene asignacion
    var registros = [];
    axios
      .post(
        "api/VeterinariosMascotas/Crear",
        {
          mascota_uq: me.component_mascota_uq,//me.unico_mascota,
          tipo: "Online"
        },
        configuracion
      )
      .then(function (response) {
        registros = response.data;
        me.veterinario_mascota_uq = registros.unico;
        //crear examne medico en blanco
        me.GuardarExamenMedico();
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.dispatch("salir");
        }
      });
  },
  GuardarExamenMedico() {
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    //crear la relacion Veterinario mascotas con el veterinario que no tiene asignacion
    var registros = [];
    axios
      .post(
        "/api/ExamenesMedicos/Crear",
        {
          veterinario_mascota_uq: me.veterinario_mascota_uq,
          sintomas: "",
        },
        configuracion
      )
      .then(function (response) {
        console.log(response);
        registros = response.data;
        me.examen_medico_uq = registros.unico;
        me.listarNumero();
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.dispatch("salir");
        }
      });
  },
  listarNumero() {
    let me = this;

    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    var registros = [];
    axios
      .get(
        "api/ExamenesMedicos/ListarNumero/" + me.examen_medico_uq,
        configuracion
      )
      .then(function (response) {
        registros = response.data;
        me.numero_examen = registros.numero;
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },

  ListarSintomasDeExamenMedico() {
    let me = this;

    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };

    axios
      .get(
        "api/ExamenesMedicosSintomas/Listar/" + me.examen_medico_uq,
        configuracion
      )
      .then(function (response) {
        me.sintomasExamenMedico = response.data;
        //change to string bool value
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  ConfirmarCierre() {
    console.log("confirme cierre");
    let me = this;
    let header = { Authorization: "Bearer " + this.$store.state.token };
    let configuracion = { headers: header };
    axios
      .put(
        "api/VeterinariosMascotas/ConfirmarCierreUsuario/" +
          me.veterinario_mascota_uq,
        configuracion
      )
      .then(function () {
        console.log("confirme cierre");
        me.e6 = 4;
      })
      .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
      );
  },
  },

  props: {
    component_mascota_uq: String,
  },
};
</script>
